export const splitWords = (name: string) => {
  const nameParts = name.split(" ")
  const lastWord = nameParts.pop() ?? ""
  const beforeLastWord = nameParts.join(" ")
  return {
    beforeLastWord: beforeLastWord === "" ? undefined : beforeLastWord,
    lastWord,
  }
}
